var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.targetSurveyType == 1)?_c('CityDataCheck'):(_vm.targetSurveyType == 2)?_c('FactFindingCheck'):(_vm.targetSurveyType == 3)?_c('ElectricityCheck'):(_vm.targetSurveyType == 4)?_c('RefrigerantCheck'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }